// extracted by mini-css-extract-plugin
module.exports = {"become-tutors":"become-tutors_1AOK","banner-wrap":"banner-wrap_2prb","text-wrap":"text-wrap_1aB9","icon-list":"icon-list_3xFs","divider":"divider_2tpr"};